import React, { Component } from 'react';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { Row, Col, Table, Popover, OverlayTrigger } from "react-bootstrap";

import { CustomCard } from "../../components/Card/CustomCard";

import { ConsultCarreras} from '../../funciones/ModalidadesFunction';
import { ConsultaSemestres} from '../../funciones/CalifDirFunction';
import { ConsultaProfesSem, ConsultAutoridades } from "../../funciones/CalifDirFunction";
import { EstPorSeccion, RendimientoXlsDir } from '../../funciones/CalifFunction';

import ListaEstudiantes from '../Estudiantes/ListaEstudiantes';
import ModalReports from '../../components/Reportes/ModalReports';
import AsistenciaEstudiantes from '../../components/Reportes/AsistenciaEstudiantes';
import CalifEstudiantes from '../../components/Reportes/CalifEstudiantes';
import ListadoEstudiantes from '../../components/Reportes/ListadoEstudiantes';
import ListadoEstudiantesE from '../../components/Reportes/ListadoEstudiantesE';

class EstudiantesList extends Component {
    state = {
        valorCarrera: { value: '', label: '- Selecciona una Carrera -' },
        carreras: [{ value: '', label: ' - Cargando Espere - ' }],
        valorSemestre: { value: '', label: '- Selecciona un Semestre -' },
        semestres: [],
        valorSeccion: { value: '', label: '- Selecciona una Sección -', prof: '', profEmail: '' },
        secciones: [],
        preloader: "",
        estudiantes: [],
        textInicial: "",
        gender:"",
        button2: {
            icon: "fa fa-file-excel-o",
            text: "Descargar en xls"
        },
        openW: false,
        reporte: "",
        aut: "",
    }

    constructor (props) {
        super (props);

        ConsultCarreras ((resp) => {
            this.setState({carreras: resp})
        })
    }

    valorSelectCarrera = (valorCarrera) => {
        this.setState({
            valorCarrera,
            valorSemestre: { value: '', label: '- Selecciona un Semestre -' },
            valorSeccion: { value: '', label: '- Selecciona una Sección -' },
            secciones: [],
        }, () => {
            ConsultaSemestres(valorCarrera.value, (resp) => {
                this.setState({
                    semestres: resp[0],
                })
            })
        });
    }

    valorSelectSemestre = (valorSemestre) => {
        this.setState({
            valorSemestre,
            valorSeccion: { value: '', label: '- Selecciona una Sección -' },
        }, () => {
            ConsultaProfesSem (valorSemestre.value, (resp) => {
                if(resp[0].length > 0) {
                   let Contenido = [];
                    let nombre = (nombre1, nombre2, ape1, ape2) => {
                        if (nombre2 === null) nombre2 = ""
                        if (ape2 === null) ape2 = ""

                        return (`${nombre1} ${nombre2} ${ape1} ${ape2}`)
                    }

                    for(let i in resp[0]){
                        Contenido.push({
                            value: resp[0][i].id, label: `${resp[0][i].carrera_name} [${resp[0][i].materia_name} - ${resp[0][i].nombre}]`,
                            prof: nombre(resp[0][i].nombre_1, resp[0][i].nombre_2, resp[0][i].apellido_1, resp[0][i].apellido_2),
                            profEmail: resp[0][i].email,
                            seccion: `${resp[0][i].carrera_name} ${resp[0][i].materia_name} - ${resp[0][i].nombre}`,
                            semestreNum: resp[0][i].semestre_num,
                            materia: resp[0][i].materia_name,
                            codigo: resp[0][i].codigo,
                            carrera: resp[0][i].carrera_name,
                            seccioName: resp[0][i].nombre
                        })
                    }

                    this.setState({
                        secciones: Contenido
                    })
                }
            })

            ConsultAutoridades (valorSemestre.value, (resp) => {
                this.setState({aut: resp})
            })
        });
    }

    valorSelectSeccion = (valorSeccion) => {
        this.setState({
            valorSeccion,
            preloader: {
                icon: "fa fa-circle-o-notch fa-spin",
                text: "Buscando estudiantes"
            },
            textInicial: "",
        }, () => {
            EstPorSeccion(valorSeccion.value, (resp) => {
                if (resp[0].length === 0){
                    this.setState({
                        estudiantes: resp[0],
                        preloader: {
                            icon: "",
                            text: ""
                        },
                        textInicial: "La sección seleccionada no tiene estudiantes inscritos",
                    })
                }else{
                    this.setState({
                        estudiantes: resp[0],
                        gender: resp[1],
                        preloader: {
                            icon: "",
                            text: ""
                        },
                        textInicial: "",
                    })
                }
            })
        })
    }

    downloadReporte = () => (e) => {
        let { valorSeccion } = this.state;
        this.setState({
            button2: {
                icon:"fa fa-spinner fa-spin",
                text: "Generando Espere"
            }
        }, () =>{
            RendimientoXlsDir(valorSeccion.profEmail, valorSeccion.value, valorSeccion.seccion, (resp) => {
                this.setState({
                    button2: {
                        icon: "fa fa-file-excel-o",
                        text: "Descargar en xls"
                    }
                })             
            })
        })
    }

    printOpciones = (reporte) => (e) => {
        let { valorCarrera, valorSemestre, valorSeccion, estudiantes } = this.state;

        if (valorCarrera.value=== ""){
            toast.error("Debes seleccionar primero la carrera",{autoClose: 4000});
            return null;
        }
        if (valorSemestre.value=== ""){
            toast.error("Debes seleccionar primero el semestre",{autoClose: 4000});
            return null;
        }
        if (valorSeccion.value=== ""){
            toast.error("Debes seleccionar primero la sección",{autoClose: 4000});
            return null;
        }
        if(estudiantes.length === 0) {
            toast.error("La sección seleccionada no tiene estudiantes inscritos. por favor selecciona otra sección",{autoClose: 4000});
            return null;
        }

        this.setState({
            openW: true,
            reporte: reporte
        })
    }

    modal = () => {
        let { openW, valorSeccion, estudiantes, aut } = this.state;
        if (openW === false) return null;

        let contenidoModal = () => {
            switch (this.state.reporte) {
                case "asistencia":
                    return (
                        <AsistenciaEstudiantes
                            autoridades = {aut}
                            seccion={valorSeccion}
                            estudiantes={estudiantes}
                        />
                    )
                case "calificaciones":
                    return (
                        <CalifEstudiantes
                            seccion={valorSeccion}
                            estudiantes={estudiantes}
                        />
                    )
                case "alumnos":
                    return (
                        <ListadoEstudiantes
                            seccion={valorSeccion}
                            estudiantes={estudiantes}
                        />
                    )
                case "alumnosE":
                    return (
                        <ListadoEstudiantesE
                            seccion={valorSeccion}
                            estudiantes={estudiantes}
                        />
                    )
                default:
                    <ListadoEstudiantes
                        seccion={valorSeccion}
                        estudiantes={estudiantes}
                    />
            }
        }

        return (
            <ModalReports
                reporte={contenidoModal()}
                titulo="Impresión"
                display= "block"
                cerrar = {() => {this.setState({openW:false})}}
                />
        )
    }

    estudiants = () => {
        let { estudiantes } = this.state;
        if(estudiantes.length === 0) return (
            <tr>
                <td colSpan={5} align= "center" style={{padding: 5, fontSize: 12}}>
                    No existen estudiantes en esta sección
                </td>
            </tr>
        )

        let num = 1
        let numero = () => { return num ++; }

        let num2 = 1
        let numero2 = () => { return num2 ++; }

        return (
            estudiantes.map(option => (
                <ListaEstudiantes 
                    key={ `est_${numero2()}` }
                    num = {numero()}
                    est = { option }
                />
            ))
        )
    }

    estadistica = () => {
        let { estudiantes, textInicial, valorSeccion, gender, button2 } = this.state;

        let M = gender.masculino;
        let F = gender.femenino;
        let total = estudiantes.length;

        let porcentajeM = (M * 100) / total;
        let porcentajeF = (F * 100) / total;

        if (estudiantes.length === 0) return (
            <div align="center" className="text-muted custom-mt-10">{textInicial}</div>
        )

        const styles = {
            padding: 5, fontSize: 12
        }
        
        return(
            <React.Fragment>
                <div><span className="text-danger">Profesor:</span> <span className="text-muted">{valorSeccion.prof}</span></div>
                <div className="custom-alert-warning custom-mt-10" style={{fontSize:10}}>Datos estadísticos de la sección <strong>{valorSeccion.seccion}</strong></div>
                <Row className="custom-mt-10">
                    <Col md={2}>
                        <div style={{fontSize:10}} className="text-danger">Inscritos:</div>
                        <div style={{fontSize:10}} className="text-muted">({estudiantes.length}) estudiantes</div>
                    </Col>
                    <Col md={5}>
                        <div style={{fontSize:10}} className="text-danger">Femenino <span className="text-muted">({F}) estudiantes</span></div>

                        <div className="progress">
                            <div className="progress-bar" role="progressbar" aria-valuenow="70"
                                aria-valuemin="0" aria-valuemax="100" style={{width: `${Math.round(porcentajeF)}%`, backgroundColor:"#A0555C"}}>
                                {Math.round(porcentajeF)}%
                            </div>
                        </div>
                    </Col>
                    <Col md={5}>
                        <div style={{fontSize:10}} className="text-danger">Masculino <span className="text-muted">({M}) estudiantes</span></div>

                        <div className="progress">
                            <div className="progress-bar" role="progressbar" aria-valuenow="70"
                                aria-valuemin="0" aria-valuemax="100" style={{width: `${Math.round(porcentajeM)}%`, backgroundColor:"#1f2f6e"}}>
                                {Math.round(porcentajeM)}%
                            </div>
                        </div>
                    </Col>
                    
                    <Col md={12} align="right" className="custom-mt-10">
                        <button className="btn btn-success" onClick = {this.downloadReporte()} style={{borderWidth: 1}}><i className={button2.icon}></i> {button2.text}</button>
                    </Col>
                    
                    <Col md={12} className="custom-mt-10">
                        <div className="table-responsive">
                            <Table striped hover bordered>
                                <tbody>
                                    <tr className="custon-back-color">
                                        <td width={30} style={styles}><strong>N°</strong></td>
                                        <td width="20%" style={styles}><strong>Cédula</strong></td>
                                        <td width="80%" colSpan={2} style={styles}><strong>Estudiantes</strong></td>
                                    </tr>
                                    {this.estudiants()}
                                </tbody>
                            </Table>
                        </div>
                    </Col>

                    <Col md={12} align="right" className="custom-mt-10">
                        <button className="btn btn-success" onClick = {this.downloadReporte()} style={{borderWidth: 1}}><i className={button2.icon}></i> {button2.text}</button>
                    </Col>
                </Row>
            </React.Fragment>
        )
    }


    contenido = () => {
        let { valorCarrera, carreras, valorSemestre, semestres, valorSeccion, secciones, preloader } = this.state;

        let styles = {
            cursor:"pointer",
            paddingTop:5,
            paddingBottom:5,
            fontSize:10
        }
        let printList = (
            <Popover>
                <div className="text-danger" style={styles} onClick={this.printOpciones("asistencia")}><i className="fa fa-file-o"></i> Listado de Asistencia</div>
                {/* <div className="text-danger" style={styles} onClick={this.printOpciones("calificaciones")}><i className="fa fa-graduation-cap"></i> Registro de Calificaciones</div> */}
                <div className="text-danger" style={styles} onClick={this.printOpciones("alumnos")}><i className="fa fa-university"></i> Alumnos por materia</div>
                <div className="text-danger" style={styles} onClick={this.printOpciones("alumnosE")}><i className="fa fa-university"></i> Alumnos por materia (Con Email)</div>
            </Popover>
        )
        
        return (
            <React.Fragment>
                <Row>
                    <Col md={12}>
                        <div className="custom-alert-info">
                            <Row>
                                <Col md={6}>
                                    <Select
                                        isSearchable ={true}
                                        value={valorCarrera}
                                        onChange={this.valorSelectCarrera}
                                        options={carreras}
                                    />
                                    <span className="text-muted" style={{fontSize: 10}}>Carreras</span>
                                </Col>
                                <Col md={6}>
                                    <Select
                                        isSearchable ={true}
                                        value={valorSemestre}
                                        onChange={this.valorSelectSemestre}
                                        options={semestres}
                                    />
                                    <span className="text-muted" style={{fontSize: 10}}>Semestres</span>
                                </Col>
                            </Row>
                        </div>
                    </Col>
                    <Col md={9}>
                        <div className="custom-alert-warning custom-mt-10"> 
                            <Select
                                isSearchable ={true}
                                value={valorSeccion}
                                onChange={this.valorSelectSeccion}
                                options={secciones}
                            />
                            <span className="text-muted" style={{fontSize: 10}}>Secciones Disponibles</span>  
                        </div>
                    </Col>
                    <Col md ={3} align="center" className="custom-mt-10">
                        <OverlayTrigger trigger="focus" placement="bottom" overlay={printList}>
                            <button className="btn btn-primary" title="Opciones de Impresión" style={{borderWidth: 1, marginTop:5}}><i className="fa fa-print"></i> Imprimir<i className="fa fa-caret-down"></i></button>
                        </OverlayTrigger>
                    </Col>
                </Row>
                <div align="center" className="text-muted custom-mt-10"><i className={preloader.icon}></i> {preloader.text}</div>
                {this.estadistica()}
            </React.Fragment>
        )
    }

    ayuda = () => (
        <React.Fragment>
            <Row>
                <Col md={12} align="justify">
                    Para ver el listado de estudiantes debes seleccionar <strong>La Carrera</strong>, <strong>El Semestre</strong> y <strong>La Sección</strong>
                </Col>

                <Col md={12} align="justify" className="custom-mt-10">
                    <div className="custom-alert-warning">Datos estadísticos...</div>
                </Col>
                <Col md={12} align="justify" className="custom-mt-10">
                    <div>En esta área encontrarás detalles de la sección respecto a la cantidad de estudiantes inscritos, separados por masculinos y femeninos con una barra indicadora del porcentaje total para cada género.</div>
                </Col>

                <Col md={5} align="justify" className="custom-mt-10">
                    <div className="progress">
                        <div className="progress-bar" role="progressbar" aria-valuenow="70"
                            aria-valuemin="0" aria-valuemax="100" style={{width: "35%", backgroundColor:"#A0555C"}}>
                            35%
                        </div>
                    </div>
                </Col>
                <Col md={7} align="justify" className="custom-mt-10">
                    Corresponde a los estudiantes femeninos inscritos.
                </Col>

                <Col md={5} align="justify" className="custom-mt-10">
                    <div className="progress">
                        <div className="progress-bar" role="progressbar" aria-valuenow="70"
                            aria-valuemin="0" aria-valuemax="100" style={{width: "65%", backgroundColor:"#1f2f6e"}}>
                            65%
                        </div>
                    </div>
                </Col>
                <Col md={7} align="justify" className="custom-mt-10">
                    Corresponde a los estudiantes masculinos inscritos.
                </Col>

                <Col md={12} align="justify" className="custom-mt-10">
                    <div>También tienes a disposición el listado de estudiantes inscritos para la sección seleccionada con sus nombres y apellidos.</div>
                </Col>

                <Col md={12} align="justify" className="custom-mt-10">
                    <div><strong style={{color:"#1f2f6e"}}>Impresión y descarga</strong></div>
                </Col>

                <Col md={4} align="justify" className="custom-mt-10">
                    <button className="btn btn-success btn-xs" style={{borderWidth: 1, fontSize:10}}><i className="fa fa-file-excel-o"></i> Descargar</button>
                </Col>
                <Col md={8} align="justify" className="custom-mt-10">
                    Este botón permite descargar en formato <strong>xls</strong> el registro de calificaciones de la sección.
                    <div style = {{fontSize: 10}} className="custom-mt-10"><strong>Importante: Al descargar el archivo .xls, asegúrate de NO CAMBIAR el nombre de la hoja (La pestaña que aparece en la parte inferior al abrir el archivo) ya que este es utilizado por el sistema.</strong></div>
                </Col>

                <Col md={4} align="justify" className="custom-mt-10">
                    <button className="btn btn-primary btn-xs" style={{borderWidth: 1, fontSize:10}}><i className="fa fa-print"></i> Imprimir <i className="fa fa-caret-down"></i></button>
                </Col>
                <Col md={8} align="justify" className="custom-mt-10">
                    Este botón permite ver los listados disponibles para la impresión
                </Col>
            </Row>
        </React.Fragment>
    )

    render() { 
        return (
            <div className="content">
                <Row>
                    <Col md={8}>
                        {this.contenido()}
                    </Col>
                    <Col md={4}>
                        <div style={{borderRadius: "4px 4px",}}>
                            <CustomCard
                                styles ={{backgroundColor: "#1f2f6e", borderTopLeftRadius: 4, borderTopRightRadius: 4,}}
                                title={<span style={{color: "#fff"}}><i className="pe-7s-help1"></i> Ayuda</span>}
                                category={<span style={{color: "#fff"}}>Listado de Estudiantes</span>}
                                color="#a80012"
                                content={this.ayuda()}
                            />
                        </div>
                    </Col>
                </Row>
                {this.modal()}
            </div>
        );
    }
}
 
export default EstudiantesList;


// WEBPACK FOOTER //
// ./src/views/Academicos/EstudiantesList.jsx